require('./style.less');

var Marionette = require('marionette'),
    SearchModelView = require('./searchPillView');


module.exports = Marionette.CollectionView.extend({

    id: 'fr-result-search-list',

    childView: SearchModelView,

    initialize: function( options ) {

        this.channel = options.channel;

    },

    childViewOptions: function() {

        return {
            channel: this.channel
        };

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/searchesView/searchPills/searchPillCollectionView.js
 ** module id = 639
 ** module chunks = 0
 **/